/* lua.js generated code undefined */
require("clover/panel/component/common/UIGroupButton")

let AdSecondConfirmPanel = xClass("AdSecondConfirmPanel", BasePanel, function () {
    let __VA_ARG = $slice(arguments, 0)
    // WARN: maybe multi result
    return cc.Node.create()
})
let RES = table(
    "font/zzgftongxin_40_greenstroke.png",
    "font/zzgftongxin_40_greenstroke.fnt",
    "font/zzgftongxin_40_brownstroke.png",
    "font/zzgftongxin_40_brownstroke.fnt",
)
AdSecondConfirmPanel.preloadRes = function (onSuccess, onFail, onCancel, useMask = false) {
    preloadWithLoading(RES, onSuccess, onFail, onCancel, useMask)
}
let _instance = null
AdSecondConfirmPanel.getInstance = function () {
    let self = this
    return _instance
}
AdSecondConfirmPanel.prototype.ctor = function (cb,cancelCb) {
    let self = this
    // super 
    // BasePanel.ctor(self)
    BasePanel.prototype.ctor.call(self);
    _instance = self
    
    this.cb = cb;
    this.cancelCb = cancelCb;
    
    self.initUI();
}
AdSecondConfirmPanel.prototype.onClose = function (callback, arg, withoutAnim) {
    let self = this
    // BasePanel.onClose(self, callback)
    BasePanel.prototype.onClose.call(self, callback, arg, withoutAnim);

}


AdSecondConfirmPanel.prototype.initUI = function () {
    let bg = ccui.Scale9Sprite.createWithSpriteFrameName("commonLib/lib_panel_frame_generalpanel_orange.png", cc.rect(50, 50, 150, 100))
    this.addChild(bg);
    bg.width = 600;
    bg.height = 400;
    
    let bg_frame = ccui.Scale9Sprite.createWithSpriteFrameName("commonLib/lib_panel_frame_generalframe_orange.png", cc.rect(20, 20, 10, 10))
    bg_frame.width = 300;
    bg_frame.height = 100;
    bg.addChild(bg_frame);
    bg_frame.setPosition(bg.width/2,bg.height/2 + 50);
    this.tipLabel = cc.LabelTTF.create("是否观看该视频", null, 26);
    bg_frame.addChild(this.tipLabel);
    this.tipLabel.setPosition(bg_frame.width/2,bg_frame.height/2);


    this.btnClose = cc.Sprite.createWithSpriteFrameName("commonLib/lib_panel_btn_close.png")
    bg.addChild(this.btnClose);
    this.btnClose.setPosition(bg.width - 50,bg.height - 50);

    quickBuildBtn(this.btnClose, UIGroupButton, PushBounceAnim, () => {
        this.onClose();
    }, true);

    this.btnConfirm = ccui.Scale9Sprite.createWithSpriteFrameName("commonLib/lib_btn_green_normal.png", cc.rect(95, 50, 10, 10))
    let icon_ad = cc.Sprite.createWithSpriteFrameName("commonLib/icon_ad.png");
    this.btnConfirm.addChild(icon_ad);
    DYAdUtil.modifyIconAttribute(icon_ad,this.btnConfirm,{
    });
    icon_ad.setPosition(icon_ad.width/2 + 20,this.btnConfirm.height/2 + 10);

    let btn_label = cc.LabelBMFont.create("确定", "font/zzgftongxin_40_greenstroke.fnt")
    this.btnConfirm.addChild(btn_label);
    btn_label.setPosition(this.btnConfirm.width/2 + 50,this.btnConfirm.height/2 + 5);

    bg.addChild(this.btnConfirm);

    quickBuildBtn(this.btnConfirm, UIGroupButton, PushBounceAnim, () => {
        if (this.cb) this.cb();
        this.onClose();
    }, true);
    this.btnConfirm.width = 220;
    this.btnConfirm.setPosition(bg.width/2 - 130, this.btnConfirm.height);


    this.btnCancel = ccui.Scale9Sprite.createWithSpriteFrameName("commonLib/lib_btn_orange_normal.png", cc.rect(95, 50, 10, 10))

    let btn_canel_label = cc.LabelBMFont.create("取消", "font/zzgftongxin_40_brownstroke.fnt")
    this.btnCancel.addChild(btn_canel_label);
    btn_canel_label.setPosition(this.btnCancel.width/2 + 10,this.btnCancel.height/2 );
    bg.addChild(this.btnCancel);
    this.btnCancel.width = 220;

    this.btnCancel.setPosition(bg.width/2 + 130, this.btnConfirm.height);

    quickBuildBtn(this.btnCancel, UIGroupButton, PushBounceAnim, () => {
        this.onClose();
        if (this.cancelCb) this.cancelCb();
    }, true);




}

module.exports = AdSecondConfirmPanel